module.exports = __webpack_public_path__ + "img/profile_picture.f9ee7fe7.png";